import { useState } from "react";
function Careers() {
     const [form, setForm] = useState({
    name: "",
    email: "",
    position: "",
    file: null,
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    if (e.target.name === "file") {
      setForm({ ...form, file: e.target.files[0] });
    } else {
      setForm({ ...form, [e.target.name]: e.target.value });
    }
    setMessage("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.position || !form.file) {
      setMessage("Please fill all fields and upload resume");
      return;
    }

    // No backend → simulate upload
    setMessage("Resume ready to send! Please email it.");

    // Open email with instructions
    window.location.href = `mailto:capitolmysuru@gmail.com?subject=Job Application - ${form.position}`;
  };

  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">

        {/* Title */}
        <h1 className="text-4xl font-bold text-blue-900 mb-10 text-center">
          Careers at Capitol Public School
        </h1>

        {/* Intro */}
        <div className="bg-white p-8 rounded-2xl shadow mb-10">
          <p className="text-gray-700 leading-relaxed">
            Capitol Public School, Mysuru invites applications from qualified
            and experienced teachers for various positions. We provide a
            professional environment that encourages growth and excellence in
            teaching careers.
          </p>
        </div>

        {/* Openings */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-yellow-500 mb-6">
            Current Openings
          </h2>

          <div className="grid md:grid-cols-2 gap-6">

            <div className="bg-white p-6 rounded-xl shadow">
              <h3 className="font-bold text-blue-900 mb-2">
                Pre-Primary Teachers
              </h3>
              <p className="text-gray-700 text-sm">
                Montessori trained / NTT candidates preferred. Strong English
                communication skills required.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow">
              <h3 className="font-bold text-blue-900 mb-2">
                Primary & Middle School Teachers
              </h3>
              <p className="text-gray-700 text-sm">
                Subjects: English, EVS, Mathematics, Hindi, Kannada, Sanskrit,
                Social Science. Graduation with specialization + B.Ed and
                minimum 3 years experience required.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow">
              <h3 className="font-bold text-blue-900 mb-2">
                Dance / Art / Performing Arts
              </h3>
              <p className="text-gray-700 text-sm">
                Classical & contemporary dance, music, and art & craft. Teaching
                experience preferred.
              </p>
            </div>

          </div>
        </div>

        {/* Remuneration */}
        <div className="bg-white p-8 rounded-2xl shadow mb-10">
          <h2 className="text-2xl font-bold text-yellow-500 mb-4">
            Remuneration
          </h2>
          <p className="text-gray-700">
            We offer an attractive salary package along with a professional
            working environment and opportunities for career growth.
          </p>
        </div>

        {/* How to Apply */}
        <div className="bg-white p-8 rounded-2xl shadow mb-10">
          <h2 className="text-2xl font-bold text-yellow-500 mb-4">
            How to Apply
          </h2>

          <p className="text-gray-700 mb-4">
            Interested candidates may send their CV along with:
          </p>

          <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
            <li>Qualification certificates</li>
            <li>Proof of Date of Birth</li>
            <li>Salary certificate</li>
            <li>Experience certificate</li>
            <li>Relieving letter (if applicable)</li>
          </ul>

          <p className="text-gray-700 mb-2">
            📧 Email:
            <a
              href="mailto:capitolmysuru@gmail.com"
              className="text-blue-900 font-semibold ml-2 hover:underline"
            >
              capitolmysuru@gmail.com
            </a>
          </p>

          <p className="text-gray-700">
            Or post your application to our school address (see Contact page).
          </p>
        </div>

        {/* Locations */}
        <div className="bg-white p-8 rounded-2xl shadow">
          <h2 className="text-2xl font-bold text-yellow-500 mb-4">
            Campuses
          </h2>

          <ul className="text-gray-700 space-y-2">
            <li>Mysuru – CBSE Curriculum</li>
            <li>J.P. Nagar (Main & Additional Campuses) – CBSE</li>
            <li>Hegde Nagar – CBSE</li>
          </ul>
        </div>

        <br/>
        <br/>

         <div className="max-w-6xl mx-auto">


        {/* Upload Form */}
        <div className="bg-white p-8 rounded-2xl shadow max-w-3xl mx-auto">

          <h2 className="text-2xl font-bold text-yellow-500 mb-6">
            Apply Now
          </h2>

          <form onSubmit={handleSubmit} className="space-y-4">

            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={form.name}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg"
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={form.email}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg"
            />

            <select
              name="position"
              value={form.position}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg"
            >
              <option value="">Select Position</option>
              <option>Pre-Primary Teacher</option>
              <option>Primary Teacher</option>
              <option>Middle School Teacher</option>
              <option>Dance / Art / Music</option>
            </select>

            <input
              type="file"
              name="file"
              accept=".pdf,.doc,.docx"
              onChange={handleChange}
              className="w-full"
            />

            {message && (
              <p className="text-green-600 text-sm">{message}</p>
            )}

            <button
              type="submit"
              className="w-full bg-yellow-400 text-blue-900 py-3 rounded-lg font-bold hover:bg-yellow-300"
            >
              Submit Application
            </button>

          </form>

        </div>

      </div>


      </div>
    </section>
  );
}

export default Careers;




 

   